import { render } from "./BrightmallOrders.vue?vue&type=template&id=62085a46&scoped=true"
import script from "./BrightmallOrders.vue?vue&type=script&lang=js"
export * from "./BrightmallOrders.vue?vue&type=script&lang=js"

import "./BrightmallOrders.vue?vue&type=style&index=0&id=62085a46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62085a46"]])

export default __exports__